import type { IStockRepository, TransactionListOptions } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createListTransactionsUseCase({ stockRepository }: Deps) {
  return async function listTransactions(options: TransactionListOptions): Promise<StockTransactionEntity[]> {
    return stockRepository.listTransactions(options);
  };
}
